import { LoggerService } from '../../services';
import { TaggedLogger } from '../../services/taggedLogger';
import { ISecurityHandler } from './securityHandler';
import { IUser } from '../../interfaces/user';
import { IPageRoles } from '../../interfaces/permission';

export class RolesSecurityHandler implements ISecurityHandler {
  private logger: TaggedLogger;
  constructor(loggerService: LoggerService) {
    this.logger = loggerService.taggedLogger('RolesSecurityHandler');
  }

  handle(user: IUser, page: IPageRoles): boolean {
    if (!page) return false;

    for (let pageRole of page.roles) {
      // check for anonymous
      if (pageRole.toLowerCase() == 'open to the world') {
        return true;
      }
      // check for 'just authrorized'
      if (page.roles.find((role) => role.toLowerCase() == 'any user') && user) {
        return true;
      }
    }

    let pageRoles = page.roles;
    let userRoles = user.roles;

    return userRoles.filter((role) => pageRoles.indexOf(role.name) !== -1).length > 0;
  }
}
